// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 20901-获取用户协议 协议类型：1-用户协议，2-隐私协议 3-退款协议 4-商品协议 5-服务协议 6-退单规则 GET /app/v1/userAgreement/${param0} */
export async function getUserAgreement(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getUserAgreementParams,
  options?: { [key: string]: any }
) {
  const { agreementType: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimUserAgreementBasicVo>(
    `/app/v1/userAgreement/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
